// extracted by mini-css-extract-plugin
export default {"rating":"vL-z","numberOfStars":"wL-z","count":"xL-z","barGraphSpacing":"yL-z","barGraph":"zL-z"};